import React from "react";
import { Rocket, Eye, Gem } from "lucide-react";
import { mvv } from "../mock";

const iconMap = { Rocket, Eye, Gem };

const MVV = () => {
  return (
    <section className="bg-white py-20">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-center text-3xl md:text-4xl font-extrabold text-neutral-900">
          Our <span className="text-rose-500">Mission</span>{" "}
          <span className="text-blue-600">Vision</span>{" "}
          <span className="text-teal-500">Values</span>
        </h2>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
          {mvv.map((m) => {
            const Icon = iconMap[m.icon];
            const titleColor =
              m.key === "MISSION" ? "text-rose-500" : m.key === "VISION" ? "text-blue-600" : "text-teal-500";
            return (
              <div
                key={m.key}
                className="bg-white rounded-2xl border border-neutral-100 shadow-[0_4px_20px_rgba(0,0,0,0.06)] hover:shadow-[0_10px_30px_rgba(0,0,0,0.10)] hover:-translate-y-1 transition-all duration-300 p-8 text-center"
              >
                <div className={`w-16 h-16 rounded-full ${m.color} mx-auto flex items-center justify-center shadow-md`}>
                  <Icon className="w-7 h-7 text-white" />
                </div>
                <h3 className={`mt-6 font-bold tracking-widest ${titleColor}`}>{m.key}</h3>
                <p className="mt-4 text-sm leading-relaxed text-neutral-600">{m.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MVV;
